//export default "http://47.100.112.3:8080";
export default "https://xm.muguangyiwang.xyz";
